import { render, staticRenderFns } from "./EditPoet.vue?vue&type=template&id=87a33186&scoped=true&lang=pug"
import script from "./EditPoet.vue?vue&type=script&lang=js"
export * from "./EditPoet.vue?vue&type=script&lang=js"
import style0 from "./EditPoet.vue?vue&type=style&index=0&id=87a33186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a33186",
  null
  
)

export default component.exports